module.exports = __webpack_public_path__ + "static/media/lamp-floor.d9279554.svg";